var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq26(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.803906,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0402,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.6277,
    y1: 12.1824,
    x2: 49.864,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.953884,
    y1: 49.8543,
    x2: 12.1902,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.3899,
    y1: 38.6199,
    x2: 49.6262,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.716038,
    y1: 0.944118,
    x2: 11.9524,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.714 30.23C20.4313 28.942 21.7567 27.7893 22.69 26.772C23.6327 25.7453 24.104 24.742 24.104 23.762C24.104 23.118 23.9407 22.6047 23.614 22.222C23.2967 21.83 22.774 21.634 22.046 21.634C21.3367 21.634 20.786 21.858 20.394 22.306C20.0113 22.7447 19.7967 23.3327 19.75 24.07H18.798C18.854 23.034 19.1713 22.2313 19.75 21.662C20.338 21.0833 21.1033 20.794 22.046 20.794C22.9513 20.794 23.684 21.0507 24.244 21.564C24.804 22.068 25.084 22.7867 25.084 23.72C25.084 24.8493 24.6127 25.946 23.67 27.01C22.7367 28.0647 21.584 29.096 20.212 30.104H25.392V30.93H18.714V30.23ZM32.6897 23.412C32.4844 22.1987 31.7797 21.592 30.5757 21.592C29.6611 21.592 28.9751 21.9467 28.5177 22.656C28.0604 23.3653 27.8504 24.5273 27.8877 26.142C28.0744 25.582 28.4291 25.1433 28.9517 24.826C29.4837 24.4993 30.0904 24.336 30.7717 24.336C31.7517 24.336 32.5264 24.6393 33.0957 25.246C33.6744 25.8433 33.9637 26.6693 33.9637 27.724C33.9637 28.34 33.8424 28.9 33.5997 29.404C33.3664 29.8987 33.0024 30.2953 32.5077 30.594C32.0224 30.8927 31.4157 31.042 30.6877 31.042C29.2971 31.042 28.3357 30.5987 27.8037 29.712C27.2811 28.8253 27.0197 27.57 27.0197 25.946C27.0197 22.4927 28.2051 20.766 30.5757 20.766C31.4717 20.766 32.1764 21.0133 32.6897 21.508C33.2031 21.9933 33.5064 22.628 33.5997 23.412H32.6897ZM30.5897 25.176C30.1511 25.176 29.7357 25.2647 29.3437 25.442C28.9517 25.6193 28.6297 25.89 28.3777 26.254C28.1351 26.6087 28.0137 27.0473 28.0137 27.57C28.0137 28.326 28.2377 28.956 28.6857 29.46C29.1337 29.964 29.7871 30.216 30.6457 30.216C31.3644 30.216 31.9384 29.9967 32.3677 29.558C32.7971 29.1193 33.0117 28.522 33.0117 27.766C33.0117 26.954 32.8017 26.3193 32.3817 25.862C31.9617 25.4047 31.3644 25.176 30.5897 25.176Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq26);
export default __webpack_public_path__ + "static/media/fq26.0780dc3e0960542182582a944981bf05.svg";
export { ForwardRef as ReactComponent };